import React, { Component } from "react";
import { Card, Avatar } from "antd";
import F from "../Functions";
import { isEqual, isEqualWith } from "lodash";

const gridStyle = {
  width: "25%",
  textAlign: "center",
  marginRight: "10px",
  borderRadius: "10px",
};

class CreateBfileAutoHome extends Component {
  render() {
    const { home_auto, wizard } = this.props;

    //  F.log("recommended_limit==>>" + JSON.stringify(auto_list));
    //  F.log("recommended_limit_2==>>" + JSON.stringify(home_list));

    F.log("recommended_limit==>>" + JSON.stringify(home_auto));

    // wizard.auto_policy_recommended_limit = home_auto[0].value;
    // wizard.home_policy_recommended_limit_2 = home_auto[1].value;

    // updateField("auto_policy_recommended_limit", home_auto[0].value);
    // updateField("home_policy_recommended_limit_2", home_auto[1].value);

    return (
      <Card bordered={false}>
        {home_auto.map((ha, i) => {
          // F.log("recommended_limit==>>" + JSON.stringify(ha));
          return ha.value ? (
            <Card.Grid style={gridStyle} hoverable={false} key={`${i}`}>
              <Card.Meta
                avatar={<Avatar src={ha.icon} size="large" />}
                title={ha.title}
                description={ha.value}
              />
            </Card.Grid>
          ) : null;
        })}
      </Card>
    );
  }
}

export default CreateBfileAutoHome;



// WEBPACK FOOTER //
// ./src/components/create-bfile-auto-home.js